// extracted by mini-css-extract-plugin
export default {"container":"Selection-module__container--aiuiu","checkbox":"Selection-module__checkbox--usQJl"};